import React from 'react';
import { useNavigate } from 'react-router-dom';
import { convertDateToJalaali } from '../../utils/convertDate.js';
import { Button } from '@mui/material';
import DataTablePagination from '../../components/Table/DataTablePagination.jsx';
import { getAllPaymentsService } from '../../services/paymentsServices.js';
import PaymentStatus from './additionFields/PaymentStatus.jsx';
import IsPaid from './additionFields/isPaid.jsx';
import EmailAndPhone from '../Users/additionFields/EmailAndPhone.jsx';

const options = [
    {
        value: "",
        text: "پرداخت شده"
    },
    {
        value: "f",
        text: "پرداخت نشده"
    }
];

const Payments = () => {
    const navigate = useNavigate();

    const paymentsCols = [
        {
            field: "id",
            text: "#"
        },
        {
            field: null,
            text: "ایمیل / شماره تلفن مشتری",
            element: (rowData) => <EmailAndPhone rowData={rowData.user_info} />
          },
        {
            field: null,
            text: "کد رهگیری",
            element: (rowData) => <span className={`${rowData.reference_id ? "" : "text-red-500"}`}>{rowData.reference_id || "ندارد"}</span> 
        },
        {
            field: null,
            text: "مبلغ",
            element: (rowData) => <span>{rowData.transaction_price ? rowData.transaction_price.toLocaleString() : ""}</span> 
        },
        {
            field: null,
            text: "وضعیت پرداخت",
            element: (rowData) => <IsPaid rowData={rowData} />
        },
        {
            field: null,
            text: "توضیحات پرداخت",
            element: (rowData) => <PaymentStatus rowData={rowData} />
        },
        {
            field: null,
            text: "جزئیات سفارش",
            element: (rowData) => {
                return (
                    <Button variant="contained" color="success"
                        onClick={() => navigate("/payments/order", {
                            state: {
                                code: rowData.order_code.code
                            }
                        })}
                    >
                        اطلاعات سفارش
                    </Button>
                )
            }
        },
    ];

    return (
        <DataTablePagination
        tableCols={paymentsCols}
        title="پرداخت‌ها"
        searchTitle="ایمیل یا شماره"
        APIFunction={getAllPaymentsService}
        dataField="transactions"
        hasOutlet={true}
        hasCatergory={true}
        categoryOptions={options}
        >
        </DataTablePagination>
    );
}

export default Payments;
